import "./_functions";
import "./_components";
import "./_sections";
import Select from "./functions/select";

new Select('.header__language').renderSelect();
